interface AiGenerateProps {
    width?: number;
    height?: number;
    color?: string;
    inverse?: boolean;
}

const INVERSE_PATH =
    'M3.8562 0.276001C3.97215 0.276008 4.08448 0.316308 4.17399 0.390006C4.2635 0.463703 4.32461 0.566215 4.34687 0.680001C4.62087 2.07467 5.71687 3.18 7.0622 3.45C7.17523 3.47295 7.27685 3.53427 7.34984 3.62358C7.42283 3.71288 7.46271 3.82467 7.46271 3.94C7.46271 4.05534 7.42283 4.16713 7.34984 4.25643C7.27685 4.34573 7.17523 4.40705 7.0622 4.43C5.7162 4.70067 4.62087 5.804 4.34687 7.19867C4.32458 7.31243 4.26345 7.4149 4.17395 7.48857C4.08444 7.56223 3.97212 7.60251 3.8562 7.60251C3.74028 7.60251 3.62796 7.56223 3.53846 7.48857C3.44896 7.4149 3.38783 7.31243 3.36554 7.19867C3.0922 5.804 1.9962 4.70067 0.650204 4.43067C0.536814 4.40804 0.43477 4.34682 0.361445 4.25741C0.28812 4.16801 0.248047 4.05596 0.248047 3.94033C0.248047 3.82471 0.28812 3.71266 0.361445 3.62326C0.43477 3.53385 0.536814 3.47263 0.650204 3.45C1.9962 3.17933 3.0922 2.07467 3.36554 0.680001C3.3878 0.566215 3.44891 0.463703 3.53842 0.390006C3.62792 0.316308 3.74026 0.276008 3.8562 0.276001ZM15.0275 3.96333C13.9942 2.928 12.4075 3 11.4475 3.96333L10.8415 4.57133L14.4202 8.15L15.0255 7.55333C15.0289 7.54985 15.0323 7.54629 15.0355 7.54267C15.9869 6.52067 15.9982 4.93733 15.0275 3.96333ZM4.41887 11.0153L10.1355 5.27933L13.7089 8.85267L7.93754 14.5453C7.8959 14.5865 7.84416 14.6159 7.78754 14.6307L3.66354 15.7093C3.60728 15.724 3.54817 15.7237 3.49207 15.7085C3.43596 15.6932 3.38482 15.6636 3.34371 15.6225C3.3026 15.5814 3.27296 15.5302 3.25773 15.4741C3.2425 15.418 3.2422 15.3589 3.25687 15.3027L4.3322 11.1673C4.34704 11.1099 4.37696 11.0574 4.41887 11.0153Z';

const AiGenerate = ({width = 16, height = 16, color = 'currentColor', inverse = false}: AiGenerateProps) => {
    if(inverse) {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox="0 0 16 16"
                fill="none"
            >
                <path fillRule="evenodd" clipRule="evenodd" d={INVERSE_PATH} fill={color} />
            </svg>
        );
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M0.729004 3.85502C2.27778 3.54366 3.52475 2.28154 3.83658 0.692703C4.14841 2.28154 5.39506 3.54366 6.94384 3.85502M6.94384 3.85682C5.39506 4.16818 4.1481 5.4303 3.83627 7.01913C3.52444 5.4303 2.27778 4.16818 0.729004 3.85682"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5754 5.07813L13.688 8.19067M7.55555 14.2245L3.43115 15.3035L4.50709 11.1676L11.5353 4.11558C12.3722 3.27643 13.747 3.21649 14.6436 4.11558C15.4804 4.95474 15.4804 6.33332 14.6436 7.2324L7.55555 14.2245Z"
                stroke={color}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AiGenerate;
